import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PseudoStates } from '@cordata/buffet';
import { authorizedInstance as py } from '~/utils';
import { MatchStatus } from '~/utils/const/identity';
import SacwisDataCard from './SacwisDataCard';
import EhrDataCard from './EhrDataCard';

const MatchDetails = ({
  matchStatusId,
  sacwisPersonId,
}) => {
  const [refetch, setRefetch] = useState(0);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const url = matchStatusId === MatchStatus.Unmatched
      ? 'api/data/public/list-view-cs-tbl-unmatched-source-child'
      : 'api/data/public/list-view-cs-match-queue';

    py
      .get(url, { params: { sacwisPersonId } })
      .then(r => r.data.data)
      .then(r => {
        setData(r);
        setStatus('success');
      })
      .catch(e => {
        console.error('e:', e);
        setStatus('error');
      });
  }, [refetch]);

  if (status !== 'success') return <PseudoStates status={status} />;

  return (
    <div className="d-flex justify-content-around dispute-match-table">
      <div className="w-100 mr-5 mb-2">
        <SacwisDataCard
          matchStatusId={matchStatusId}
          data={data[0]}
          fetchData={() => setRefetch(old => old + 1)}
        />
      </div>

      {matchStatusId !== MatchStatus.Unmatched && (
        <div className="w-100">
          <EhrDataCard
            matchStatusId={matchStatusId}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

MatchDetails.propTypes = {
  matchStatusId: PropTypes.string.isRequired,
  sacwisPersonId: PropTypes.string.isRequired,
};

export default MatchDetails;
